// extracted by mini-css-extract-plugin
export default {"SelectableCard":"SelectableCard_SelectableCard__OssXb","SelectableCard--selected":"SelectableCard_SelectableCard--selected__6LdI+"};